import './index.css';



// WEBPACK FOOTER //
// ../src4js/pc4public/portal/wea-color-input/style/index.js